module.exports = __webpack_public_path__ + "img/reports--icon.faa2aa14.svg";